
import AxiosAPI from "./AxiosAPI";

export const handleAddOmniSettings = async (data) => {
  try {
    const response = await AxiosAPI.post("/onlinestores/omni-settings", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add profile:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};


export const fetchOmniSettings = async () => {
  try {
    const response = await AxiosAPI.get("/onlinestores/omni-settings");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const fetchOmniPages = async (registrationId) => {
  try {
    const response = await AxiosAPI.get(`/onlinestores/omni-pages/${registrationId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};



export const fetchOmniPaymentGatewaySettings = async () => {
  try {
    const response = await AxiosAPI.get("/onlinestores/payment-gateway-settings");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const handleAddOmniPaymentGatewaySettings = async (data) => {
  try {
    const response = await AxiosAPI.post("/onlinestores/payment-gateway-settings", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add payment setting:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};

export const handleAddOmniPage = async (data) => {
  try {
    const response = await AxiosAPI.post("/onlinestores/omni-pages", data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("Response from add payment setting:", response);
    return response.data;
  } catch (error) {
    console.error("API Error:", error.response?.data || error.message);
    throw error;
  }
};


export const deleteOmniPages = async (key) => { 
  try {
    const response = await AxiosAPI.delete(
      `/onlinestores/omni-pages/${key}`
    );
    return response.data;
  } catch (err) {
    console.log(err);
    
  }
};




